<section>
  <form [formGroup]="form">
    <div class="d-flex flex-row w-100">
      <div
        class="input-group"
        [class.d-flex]="showInputField"
      >
        <input
          #query
          type="text"
          class="form-control no-round-right h-100 user-select-none"
          [placeholder]="placeholder"
          *ngIf="displayInputField"
          formControlName="searchString"
          (input)="newSearch(query.value)"
        >
      </div>

      <button
        *ngIf="searchStringLength === 0"
        [class]="'btn btn-icon d-none d-md-block user-select-none ' + btnColorClass"
        [class.no-round-left]="!inputFieldHidden || showInputField"
        (click)="showInputField=!showInputField"
      >
        <tr-icon [white]="whiteIconColorEnabled" [icon]="icon.search"></tr-icon>
      </button>

      <button
        *ngIf="searchStringLength === 0"
        [class]="'btn btn-icon d-md-none d-block user-select-none ' + btnColorClass"
        [class.no-round-left]="!inputFieldHidden || showInputField"
        (click)="showInputField=!showInputField"
      >
        <tr-icon [white]="whiteIconColorEnabled" [icon]="icon.search"></tr-icon>
      </button>
    </div>

    <button
      *ngIf="searchStringLength > 0"
      [class]="'btn btn-icon d-none d-md-block no-round-left user-select-none ' + btnColorClass"
      (click)="clearSearchField();"
    >
      <tr-icon [icon]="icon.cancel" [white]="whiteIconColorEnabled"></tr-icon>
    </button>

    <button
      *ngIf="searchStringLength > 0"
      [class]="'btn btn-icon d-md-none d-block user-select-none ' + btnColorClass"
      [class.no-round-left]="showInputField"
      (click)="clearSearchField();"
    >
      <tr-icon [icon]="icon.cancel" [white]="whiteIconColorEnabled"></tr-icon>
    </button>

    <div class="error user-select-none" *ngIf="searchStringLength > 0 && searchStringLength < minQueryLength && form.touched">
      Query should have {{ minQueryLength }} or more characters
    </div>
  </form>
</section>
